import { useHistory } from 'react-router-dom';

const FormRegisterAction = ({ disabled = false, isLoading = false }) => {
  const history = useHistory();

  return (
    <>
      <button className="btn w-100 mt-2 btn-register" type="submit" disabled={disabled}>
        {isLoading ? 'Loading...' : 'Daftar'}
      </button>
      <p className="text-center mt-4">
        Sudah punya akun?
        <a
          className="ml-1"
          style={{ color: 'green', cursor: 'pointer' }}
          onClick={() =>
            history.push('/login', {
              pageChannel: 'Register Page',
            })
          }
        >
          Login di sini
        </a>
      </p>
    </>
  );
};

export default FormRegisterAction;
